import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Table } from "react-bootstrap";

import { fetchDatasetDocumentation } from "../services/api";


function MarkdownDoc({
  path,
  datasetId,
  getAccessTokenSilently,
}) {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadDocument = async () => {
      setLoading(true);
      setError(null);
      setContent("");

      try {
        let markdownContent;

        if (datasetId) {
          markdownContent = await fetchDatasetDocumentation({
            getAccessTokenSilently,
            datasetId,
          });
        } else if (path) {
          const response = await fetch(path);

          if (!response.ok) {
            throw new Error(
              `Network response was not ok: ` +
              `${response.status} ${response.statusText} for ${path}`
            );
          }

          markdownContent = await response.text();
        } else {
          throw new Error("No document source was provided.");
        }

        if (mounted) {
          setContent(markdownContent);
        }
      } catch (loadError) {
        console.error("Error fetching markdown:", loadError);

        if (mounted) {
          setError(loadError.message);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadDocument();

    return () => {
      mounted = false;
    };
  }, [
    path,
    datasetId,
    getAccessTokenSilently,
  ]);

  if (loading) {
    return <p>Loading document...</p>;
  }

  if (error) {
    return <p>Error loading document: {error}</p>;
  }

  if (!content) {
    return <p>No content to display.</p>;
  }

  return (
    <div className="markdown-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          img: ({ node, ...props }) => (
            <img
              {...props}
              style={{
                maxWidth: "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              }}
              alt={props.alt || ""}
            />
          ),
          table: ({ node, ...props }) => (
            <Table
              striped
              bordered
              hover
              responsive
              {...props}
            />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}

export default MarkdownDoc;